import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export abstract class ConfirmModel {
    public header!: string;
    public message!: string;
    public no_action_button!: string;
    public confirm_action_button!: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: 'confirm.dialog.html',
    standalone: false
})
export class ConfirmDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public confirm_data: ConfirmModel,
    ) {
    }
}
